/* eslint-disable max-lines */
import CmsBlock from 'Component/CmsBlock';
import ContentWrapper from 'Component/ContentWrapper';
import ExpandableContent from 'Component/ExpandableContent';
import Link from 'Component/Link';
import Logo from 'Component/Logo';
import { CURRENT_VERSION } from 'Component/NewVersionPopup/NewVersionPopup.config';
import StoreSelector from 'Component/StoreSelector';
import {
    Footer as SourceFooter
} from 'SourceComponent/Footer/Footer.component';
import history from 'Util/History';
import media from 'Util/Media';
import { LOGO_MEDIA } from 'Util/Media/Media';

import {
    HORIZONTAL,
    LEGAL_LINKS, NEWSLETTER_COLUMN, PAYMENT_CARDS,
    SOCIAL_LINKS
} from './Footer.config';
/** @namespace Bodypwa/Component/Footer/Component */
export class FooterComponent extends SourceFooter {
    static defaultProps = {
        copyright: '',
        isVisibleOnMobile: false,
        logo_alt: '',
        logo_height: '',
        logo_width: '',
        isCheckout: false
    };

    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    shouldComponentUpdate(nextProps) {
        const {
            device: {
                isMobile
            },
            isVisibleOnMobile,
            copyright,
            newsletterActive,
            isCheckout
        } = this.props;

        const {
            device: {
                isMobile: nextIsMobile
            },
            isVisibleOnMobile: nextIsVisibleOnMobile,
            copyright: nextCopyright,
            newsletterActive: nextNewsletterActive,
            isCheckout: nextIsCheckout
        } = nextProps;

        return isMobile !== nextIsMobile
            || isVisibleOnMobile !== nextIsVisibleOnMobile
            || copyright !== nextCopyright
            || newsletterActive !== nextNewsletterActive
            || isCheckout !== nextIsCheckout;
    }

    renderContent() {
        const { footer_content: { footer_cms } = {} } = window.contentConfiguration;

        if (footer_cms) {
            return this.renderCmsBlockWrapper();
        }

        return (
            <div block="Footer" elem="Content">
                <CmsBlock identifier="top-footer-block" />
                { this.renderColumns() }
            </div>
        );
    }

    renderColumn = (column) => {
        const {
            title,
            expandable,
            columnActiveKey,
            items,
            isItemsHorizontal
        } = column;
        const { device } = this.props;
        const contentMods = isItemsHorizontal ? { direction: HORIZONTAL } : {};

        const isExpandable = expandable && device.isMobile;

        const ExpandableClass = isExpandable ? 'ColumnExpandable' : 'Column';

        const { [columnActiveKey]: isColumnActive } = this.props;

        if (columnActiveKey && !isColumnActive === true) {
            return null;
        }

        return (
            <ExpandableContent
              key=""
              heading={ expandable ? title : false }
              mix={ { block: 'Footer', elem: ExpandableClass } }
              class="test"
                // eslint-disable-next-line react/jsx-boolean-value
              isArrow={ true }
              isContentExpanded={ !isExpandable }
            >
                { /* eslint-disable-next-line @scandipwa/scandipwa-guidelines/jsx-no-conditional */ }
                { title && !device.isMobile
                    ? (
                        <h3 block="Footer" elem="ColumnTitle">{ title }</h3>
                    ) : null }
                <div
                  block="Footer"
                  elem="ColumnContent"
                  mods={ contentMods }
                >
                    { items.map(this.renderColumnItem) }

                </div>
            </ExpandableContent>
        );
    };

    renderVersion() {
        return (
            <div block="Footer" elem="Version">
                { CURRENT_VERSION }
            </div>
        );
    }

    renderStoreSwitcher() {
        return <StoreSelector isSimple storeSelectorId="FOOTER_STORE_SELECTOR" />;
    }

    renderCopyrightContent(isCheckout) {
        const { copyright } = this.props;
        const storeSwitcher = isCheckout ? '' : this.renderStoreSwitcher();
        // TODO: temp removal of legal links untill logic is implemented
        // const legalLinks = isCheckout ? '' : this.renderLegalLinks();

        return (
            <ContentWrapper
              mix={ { block: 'Footer', elem: 'CopyrightContentWrapper' } }
              wrapperMix={ { block: 'Footer', elem: 'CopyrightContent', mods: { Checkout: isCheckout } } }
            >
                { storeSwitcher }
                <div block="Footer" elem="Copyright">
                    { copyright }
                    <CmsBlock identifier="legal-links" />
                    { /* { legalLinks } */ }
                </div>
            </ContentWrapper>
        );
    }

    renderLogoImage() {
        const {
            header_logo_src,
            logo_alt
        } = this.props;

        // if no src defined from the backend, pass null in order to display placeholder
        // and prevent unnecessary load of corrupted resource
        const logoSrc = header_logo_src ? media(header_logo_src, LOGO_MEDIA) : null;
        return (
            <Logo
              src={ logoSrc }
              alt={ logo_alt }
              title={ logo_alt }
            />
        );
    }

    renderLogo(isVisible = false) {
        const { isLoading } = this.props;

        if (isLoading) {
            return null;
        }

        return (
            <ContentWrapper
              isNotSection
              wrapperMix={ { block: 'Footer' } }
              label=""
            >
                <Link
                  to="/"
                  aria-label="Go to homepage by clicking on ScandiPWA logo"
                  aria-hidden={ !isVisible }
                  tabIndex={ isVisible ? 0 : -1 }
                  block="Footer"
                  elem="LogoWrapper"
                  mods={ { isVisible } }
                  key="logoFooter"
                >
                    { this.renderLogoImage() }
                </Link>
            </ContentWrapper>
        );
    }

    renderSocialLinks() {
        return (
            <ContentWrapper
              wrapperMix={ { block: 'Footer' } }
              isNotSection
              label=""
            >
                { SOCIAL_LINKS.map(this.renderColumn) }
            </ContentWrapper>
        );
    }

    renderLegalLinks() {
        return (
            <div className="Footer-LegalLinks">
                <ContentWrapper
                  isNotSection
                  label=""
                >
                    { LEGAL_LINKS.map(this.renderColumn) }
                </ContentWrapper>
            </div>
        );
    }

    renderPaymentCards() {
        const { paymentCardsColumns: { items, isItemsHorizontal } = {} } = this.props;
        if (!isItemsHorizontal) {
            return null;
        }
        const paymentCardsColumnsFormated = [{
            isItemsHorizontal,
            items: items.map((item) => {
                const newItem = {
                    src: PAYMENT_CARDS.items[item.src],
                    title: item.title
                };

                return newItem;
            })
        }];

        return (
            <ContentWrapper
              isNotSection
              className="Footer"
              wrapperMix={ { block: 'Footer' } }
              label=""
            >
                <div className="Footer-PaymentCards">
                    { paymentCardsColumnsFormated.map(this.renderColumn) }
                </div>
            </ContentWrapper>
        );
    }

    renderBottomContent() {
        const { device } = this.props;
        const logoDesktop = !device.isMobile ? this.renderLogo(true) : '';
        return (
            <div block="Footer" elem="BottomContent">
                { logoDesktop }
                 { this.renderPaymentCards() }
                { this.renderSocialLinks() }
            </div>
        );
    }

    renderColumns() {
        const { footerColumns } = this.props;

        if (!footerColumns.length) {
            return null;
        }

        return (
            <ContentWrapper
              isNotSection
              wrapperMix={ { block: 'Footer', elem: 'Columns Footer-Column_links-subscribe' } }
              label=""
            >
                { footerColumns.map((item) => this.renderColumn(item)) }
                { this.renderColumn(NEWSLETTER_COLUMN) }
            </ContentWrapper>
        );
    }

    renderColumnItemLink = ({
        href = '/', title, src, isOpenInNewTab = false
    }, i) => {
        const mods = src ? { type: 'image' } : {};

        return (
            <Link
              block="Footer"
              elem="ColumnItem"
              target={ isOpenInNewTab ? '_blank' : '_self' }
              to={ href }
              mods={ mods }
              key={ i }
              aria-label={ title }
            >
                { this.renderColumnItemContent(src, title) }
            </Link>
        );
    };

    render() {
        const { isCheckout, device: { isMobile }, footerRef } = this.props;
        const { location: { pathname } } = history;
        const isLogin = pathname.includes('/login');
        const isRegister = pathname.includes('/account/create');

        if (isMobile && (isLogin || isRegister)) {
            return null;
        }

        if (isCheckout) {
            return (
                <footer block="Footer" aria-label="Footer">
                    { this.renderCopyrightContent(isCheckout) }
                </footer>
            );
        }

        return (
            <footer block="Footer" aria-label="Footer" ref={ footerRef }>
                { this.renderContent() }
                { this.renderBottomContent() }
                { this.renderCopyrightContent() }
                { this.renderVersion() }
            </footer>
        );
    }
}

export default FooterComponent;
